import { createSelector } from 'reselect';
import { selectorFunctions } from 'redux/utils/selectors';

const { getData, getLoading } = selectorFunctions;

const getGlobalState = state => state.issuing;

export const getIssuedPageSelector = createSelector(
  [getGlobalState],
  state => state.issuedPage
);

export const getCardDetails = createSelector(
  [getGlobalState],
  state => state.cardDetails
);

export const getCardDetailsSelector = createSelector([getCardDetails], getData);

export const getCardDetailsLoadingSelector = createSelector([getCardDetails], getLoading);
